import { useContext } from '@nuxtjs/composition-api';

const getAlgoliaIndexName = (): string => {
  const { $config, app } = useContext();

  const { domainConfig, appEnv = 'acc' } = $config;
  const { websiteGroup = 'ke', websiteCountry = 'be' } = domainConfig;
  const locale = app.i18n.locale;

  const groupUpper = websiteGroup?.toUpperCase();

  return `${appEnv}-product-${groupUpper}-${websiteCountry}-${locale}`;
};

interface SortingOption {
  label: string;
  sortValue: string;
  dirValue: string;
  indexName: string;
}

const getSortingOptions = (indexName: string): readonly SortingOption[] => ([
  {
    label: 'popularity',
    sortValue: 'popularity',
    dirValue: 'desc',
    indexName: indexName
  },
  {
    label: 'price_low_high',
    sortValue: 'price',
    dirValue: 'asc',
    indexName: `${indexName}_price_asc`
  },
  {
    label: 'price_high_low',
    sortValue: 'price',
    dirValue: 'desc',
    indexName: `${indexName}_price_desc`
  }
] as const);

export const useSortingOptions = (): { indexName: string, sortingOptions: readonly SortingOption[] } => {
  const indexName = getAlgoliaIndexName();
  const sortingOptions = getSortingOptions(indexName);

  return { indexName, sortingOptions };
};

